import React, { useState } from "react";
import AppBar from "@mui/material/AppBar"
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button"
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MenuIcon from '@mui/icons-material/Menu';
import { Link } from "react-router-dom";
import HelpOutline from "@mui/icons-material/HelpOutline";
import SaveFileUploadButton from "./SaveFileUploadButton";
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import PublicIcon from '@mui/icons-material/Public';
import MapIcon from '@mui/icons-material/Map';
import SettingsIcon from '@mui/icons-material/Settings';
import FileUploadIcon from '@mui/icons-material/FileUpload';

function Navbar({showHelp, setShowHelp}: {showHelp: boolean, setShowHelp: React.Dispatch<React.SetStateAction<boolean>>}) {  
    
    const menuItems = [
        { label: 'Transfer Planner', path: '/', icon: <RocketLaunchIcon sx={{ mr: 1.5, fontSize: 20 }} /> },
        { label: 'Multi-flyby Planner', path: '/Flyby', icon: <MapIcon sx={{ mr: 1.5, fontSize: 20 }} /> },
        { label: 'Flight Planner', path: '/FlightPlan', icon: <PublicIcon sx={{ mr: 1.5, fontSize: 20 }} /> },
        { label: 'Solar System Editor', path: '/System', icon: <SettingsIcon sx={{ mr: 1.5, fontSize: 20 }} /> },
    ];
    
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const handleOpenMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    return (
        <AppBar position="static" sx={{ zIndex: 1201, pointerEvents: 'auto' }}>
            <Toolbar sx={{ minHeight: 64 }}>
                {/* Logo / Title */}
                <Typography 
                    variant="h5"
                    sx={{
                        mr: 4,
                        fontWeight: 900,
                        fontFamily: 'Orbitron',
                        letterSpacing: '0.1em',
                        color: 'primary.main',
                        textShadow: '0 0 10px rgba(0, 243, 255, 0.5)',
                        display: 'flex',
                        alignItems: 'center',
                        cursor: 'default',
                        userSelect: 'none'
                      }}
                >
                    ORBIT DYNAMICS
                </Typography>

                <div style={{ flexGrow: 1 }} />

                {/* Rightmost Menu Dropdown */}
                <Button
                    onClick={handleOpenMenu}
                    startIcon={<MenuIcon />}
                    variant="outlined"
                    sx={{
                        borderColor: 'rgba(0, 243, 255, 0.3)',
                        color: 'primary.main',
                        px: 3,
                        py: 1,
                        fontFamily: 'Orbitron',
                        fontSize: '0.9rem',
                        letterSpacing: '0.15em',
                        '&:hover': {
                            borderColor: 'primary.main',
                            backgroundColor: 'rgba(0, 243, 255, 0.1)',
                            boxShadow: '0 0 15px rgba(0, 243, 255, 0.3)'
                        }
                    }}
                >
                    MISSION MENU
                </Button>

                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleCloseMenu}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    PaperProps={{
                        sx: {
                            mt: 1.5,
                            minWidth: 280,
                            backgroundColor: 'rgba(10, 10, 20, 0.9)',
                            backdropFilter: 'blur(20px)',
                            border: '1px solid rgba(0, 243, 255, 0.3)',
                            borderRadius: 0,
                            boxShadow: '0 10px 40px rgba(0,0,0,0.8)',
                            '& .MuiMenuItem-root': {
                                py: 1.5,
                                px: 3,
                                fontFamily: 'Rajdhani',
                                fontSize: '1.1rem',
                                fontWeight: 600,
                                letterSpacing: '0.05em',
                                transition: 'all 0.2s',
                                '&:hover': {
                                    backgroundColor: 'rgba(0, 243, 255, 0.15)',
                                    color: 'primary.main',
                                    pl: 4,
                                }
                            }
                        }
                    }}
                >
                    <Typography variant="overline" style={{ padding: '8px 24px', display: 'block', color: 'rgba(255,255,255,0.4)', letterSpacing: '0.2em' }}>
                        NAVIGATION
                    </Typography>
                    {menuItems.map((item) => (
                        <MenuItem key={item.path} component={Link} to={item.path} onClick={handleCloseMenu}>
                            {item.icon}
                            {item.label}
                        </MenuItem>
                    ))}

                    <div style={{ margin: '8px 0', borderTop: '1px solid rgba(255,255,255,0.1)' }} />
                    
                    <Typography variant="overline" style={{ padding: '8px 24px', display: 'block', color: 'rgba(255,255,255,0.4)', letterSpacing: '0.2em' }}>
                        SYSTEM OPERATIONS
                    </Typography>
                    
                    <MenuItem style={{ padding: 0 }}>
                        <div style={{ width: '100%', padding: '8px 24px', display: 'flex', alignItems: 'center' }}>
                            <FileUploadIcon sx={{ mr: 1.5, fontSize: 20 }} />
                            <SaveFileUploadButton />
                        </div>
                    </MenuItem>

                    <MenuItem onClick={() => { setShowHelp(!showHelp); handleCloseMenu(); }}>
                        <HelpOutline sx={{ mr: 1.5, fontSize: 20 }} />
                        Operational Guide (Help)
                    </MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
}
export default React.memo(Navbar);
